// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kt-error-v3 {
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover; }
  .kt-error-v3 .kt-error_container .kt-error_number > h1 {
    font-size: 15.7rem;
    margin-left: 7.85rem;
    margin-top: 11.4rem;
    font-weight: 500;
    -webkit-text-stroke-width: 0.35rem;
    -moz-text-stroke-width: 0.35rem;
    text-stroke-width: 0.35rem;
    color: #A3DCF0;
    -webkit-text-stroke-color: white;
    -moz-text-stroke-color: white;
    text-stroke-color: white; }
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      .kt-error-v3 .kt-error_container .kt-error_number > h1 {
        color: white; } }
  .kt-error-v3 .kt-error_container .kt-error_title {
    margin-left: 7.85rem;
    font-size: 2.5rem;
    font-weight: 700;
    color: #48465b; }
  .kt-error-v3 .kt-error_container .kt-error_subtitle {
    margin-left: 7.85rem;
    margin-top: 3.57rem;
    font-size: 1.8rem;
    font-weight: 700;
    color: #595d6e; }
  .kt-error-v3 .kt-error_container .kt-error_description {
    margin-left: 7.85rem;
    font-size: 1.4rem;
    font-weight: 500;
    color: #404046; }

@media (max-width: 768px) {
  .kt-error-v3 .kt-error_container .kt-error_number > h1 {
    font-size: 8rem;
    margin-left: 4rem;
    margin-top: 3.5rem; }
  .kt-error-v3 .kt-error_container .kt-error_title {
    margin-left: 4rem; }
  .kt-error-v3 .kt-error_container .kt-error_subtitle {
    margin-left: 4rem;
    padding-right: 0.5rem; }
  .kt-error-v3 .kt-error_container .kt-error_description {
    margin-left: 4rem;
    padding-right: 0.5rem; } }
`, "",{"version":3,"sources":["webpack://./src/assets/css/pages/error/error-3.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB,EAAE;EACxB;IACE,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;IAClC,+BAA+B;IAC/B,0BAA0B;IAC1B,cAAc;IACd,gCAAgC;IAChC,6BAA6B;IAC7B,wBAAwB,EAAE;IAC1B;MACE;QACE,YAAY,EAAE,EAAE;EACtB;IACE,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAE;EAClB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAE;EAClB;IACE,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAE;;AAEpB;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB,EAAE;EACtB;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB;IACjB,qBAAqB,EAAE;EACzB;IACE,iBAAiB;IACjB,qBAAqB,EAAE,EAAE","sourcesContent":[".kt-error-v3 {\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-attachment: fixed;\r\n  background-size: cover; }\r\n  .kt-error-v3 .kt-error_container .kt-error_number > h1 {\r\n    font-size: 15.7rem;\r\n    margin-left: 7.85rem;\r\n    margin-top: 11.4rem;\r\n    font-weight: 500;\r\n    -webkit-text-stroke-width: 0.35rem;\r\n    -moz-text-stroke-width: 0.35rem;\r\n    text-stroke-width: 0.35rem;\r\n    color: #A3DCF0;\r\n    -webkit-text-stroke-color: white;\r\n    -moz-text-stroke-color: white;\r\n    text-stroke-color: white; }\r\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\r\n      .kt-error-v3 .kt-error_container .kt-error_number > h1 {\r\n        color: white; } }\r\n  .kt-error-v3 .kt-error_container .kt-error_title {\r\n    margin-left: 7.85rem;\r\n    font-size: 2.5rem;\r\n    font-weight: 700;\r\n    color: #48465b; }\r\n  .kt-error-v3 .kt-error_container .kt-error_subtitle {\r\n    margin-left: 7.85rem;\r\n    margin-top: 3.57rem;\r\n    font-size: 1.8rem;\r\n    font-weight: 700;\r\n    color: #595d6e; }\r\n  .kt-error-v3 .kt-error_container .kt-error_description {\r\n    margin-left: 7.85rem;\r\n    font-size: 1.4rem;\r\n    font-weight: 500;\r\n    color: #404046; }\r\n\r\n@media (max-width: 768px) {\r\n  .kt-error-v3 .kt-error_container .kt-error_number > h1 {\r\n    font-size: 8rem;\r\n    margin-left: 4rem;\r\n    margin-top: 3.5rem; }\r\n  .kt-error-v3 .kt-error_container .kt-error_title {\r\n    margin-left: 4rem; }\r\n  .kt-error-v3 .kt-error_container .kt-error_subtitle {\r\n    margin-left: 4rem;\r\n    padding-right: 0.5rem; }\r\n  .kt-error-v3 .kt-error_container .kt-error_description {\r\n    margin-left: 4rem;\r\n    padding-right: 0.5rem; } }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
